// CORTE 4-B anexo J — formatos locales (fechas DD/MM vs MM/DD, números, bandera)
export function userLocale(lang, countryCode) {
  const cc = (countryCode || "").toUpperCase();
  if (lang === "es") return "es-PE";
  if (lang === "pt") return "pt-BR";
  if (lang === "fr") return "fr-FR";
  return cc === "US" ? "en-US" : "en-GB";
}

export function fmtDate(d, locale) {
  if (!d) return "";
  try {
    return new Date(d).toLocaleDateString(locale || "es-PE", { day: "2-digit", month: "2-digit", year: "numeric" });
  } catch (_e) { return String(d); }
}

export function fmtNumber(n, locale) {
  try { return Number(n).toLocaleString(locale || "es-PE"); } catch (_e) { return String(n); }
}

export function flagEmoji(cc) {
  const c = (cc || "").toUpperCase();
  if (!/^[A-Z]{2}$/.test(c)) return "";
  return String.fromCodePoint(...[...c].map((ch) => 127397 + ch.charCodeAt(0)));
}

export const COUNTRY_NAMES_ES = {
  PE: "Perú", IN: "India", FR: "Francia", BR: "Brasil", US: "Estados Unidos",
  MX: "México", AR: "Argentina", CL: "Chile", CO: "Colombia", EC: "Ecuador",
  BO: "Bolivia", ES: "España", DE: "Alemania", PT: "Portugal", UY: "Uruguay",
  PY: "Paraguay", VE: "Venezuela", CA: "Canadá", GB: "Reino Unido", IT: "Italia",
};
